import Vue from 'vue'
import dayjs from 'dayjs'
import defaultState from './state'
import { carStatus } from '@/constants/car'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setKw(state, kw) {
    Vue.set(state, 'kw', kw)
  },
  setPicked(state, picked) {
    Vue.set(state, 'picked', picked)
  },
  setTask(state, task) {
    Vue.set(state, 'task', task)
  },
  setLastUpdateTime(state, time) {
    Vue.set(state, 'lastUpdateTime', time)
  },
  setSwitchSpeech(state, switchSpeech) {
    Vue.set(state, 'switchSpeech', switchSpeech)
  },
  setRefreshClick(state) {
    Vue.set(state, 'refreshClick', !state.refreshClick)
  },
  /* 司機即時訊息modal */
  setIsDriverMsgModalOpen(state) {
    Vue.set(state, 'isDriverMsgModalOpen', !state.isDriverMsgModalOpen)
  },
  setDriverMsgModalList(state, { data, paging }) {
    Vue.set(state.driverMsgModal, 'list', data)
    Vue.set(state.driverMsgModal, 'paging', paging)
  },
  /* bill */
  setBillList(state, billList) {
    Vue.set(state, 'billList', billList)
  },
  setBillModal(state, modalDetail) {
    Vue.set(state, 'billModal', modalDetail)
  },
  setModalState(state, isModalOpen) {
    Vue.set(state, 'isModalOpen', isModalOpen)
  },
  // HACK: 可以考慮移除
  setBillPaging(state, { currentPage, npp, totalPages, totalEntries }) {
    Vue.set(state.billPaging, 'currentPage', currentPage)
    Vue.set(state.billPaging, 'npp', npp)
    Vue.set(state.billPaging, 'totalPages', totalPages)
    Vue.set(state.billPaging, 'totalEntries', totalEntries)
  },
  setBillPagingNpp(state, npp) {
    Vue.set(state.billPaging, 'npp', npp)
  },
  setBillPagingCurrentPage(state, currentPage) {
    Vue.set(state.billPaging, 'currentPage', currentPage)
  },
  setBillPagingTotalPages(state, totalPages) {
    Vue.set(state.billPaging, 'totalPages', totalPages)
  },
  setBillPagingTotalEntries(state, totalEntries) {
    Vue.set(state.billPaging, 'totalEntries', totalEntries)
  },
  /* reserve */
  setReserveList(state, reserveList) {
    Vue.set(state, 'reserveList', reserveList)
  },
  setReservePagingNpp(state, npp) {
    Vue.set(state.reservePaging, 'npp', npp)
  },
  setReservePagingCurrentPage(state, currentPage) {
    Vue.set(state.reservePaging, 'currentPage', currentPage)
  },
  setReservePagingTotalPages(state, totalPages) {
    Vue.set(state.reservePaging, 'totalPages', totalPages)
  },
  setReservePagingTotalEntries(state, totalEntries) {
    Vue.set(state.reservePaging, 'totalEntries', totalEntries)
  },
  setReserveCount(state, num) {
    Vue.set(state, 'reserveCount', num)
  },
  setDriverInfo(state, driverInfo) {
    /* console.log('driver info', driverInfo) */
    /* 格式化更新日期 */
    if (driverInfo.updatedDate) {
      driverInfo.updatedDate = dayjs(driverInfo.updatedDate).format(
        'YYYY-MM-DD HH:mm',
      )
    }
    if (driverInfo.driverGrabOrderDate) {
      driverInfo.driverGrabOrderDate = dayjs(
        driverInfo.driverGrabOrderDate,
      ).format('YYYY-MM-DD HH:mm')
    }
    if (driverInfo.orderCreatedDate) {
      driverInfo.orderCreatedDate = dayjs(driverInfo.orderCreatedDate).format(
        'YYYY-MM-DD HH:mm',
      )
    }
    /* Vue.set(state, 'driverInfo', { ...driverInfo, carLeaveFactoryYear }) */
    Vue.set(state, 'driverInfo', { ...driverInfo })
  },
  setReserveDriverInfo(state, { driverInfo, driverStatus, onLocationGps }) {
    /* console.log('reserve driverInfo', driverInfo) */
    /* console.log('reserve driverStatus', driverStatus) */
    /* 撰寫車齡欄位 */
    let carLeaveFactoryYear = ''
    if (driverInfo.car_year && driverInfo.car_year !== '') {
      /* const yearDiff = dayjs().format('YYYY') - dayjs(driverInfo.carYear).format('YYYY') */
      const yearDiff = dayjs().diff(`${driverInfo.car_year}-01-01`, 'year')
      carLeaveFactoryYear = yearDiff > 0 ? `${yearDiff}年` : '<1年'
      /* console.log('driverInfo.carYear', driverInfo.carYear)
      console.log('carLeaveFactoryYear', carLeaveFactoryYear) */
    }
    /* 格式化更新日期 */
    if (driverInfo.updated_at) {
      driverInfo.updated_at = dayjs(driverInfo.updated_at).format(
        'YYYY-MM-DD HH:mm',
      )
    }
    Vue.set(state, 'driverInfo', {
      driverCallNumber: driverInfo.call_number,
      licence: driverInfo.licence,
      driverStatus: carStatus[driverInfo.status] || '失聯',
      driverStatusNumber: driverStatus.status,
      driverPositionGps: {
        longitude: driverStatus.lng,
        latitude: driverStatus.lat,
      },
      driverGrabOrderGps: { longitude: null, latitude: null },
      passengerPickUpLocationGps: {
        longitude: onLocationGps.longitude,
        latitude: onLocationGps.latitude,
      },
      carYear: driverInfo.car_year,
      carLeaveFactoryYear: carLeaveFactoryYear,
      driverName: driverInfo.name,
      gender: driverInfo.gender ? '女' : '男',
      carBrand: driverInfo.car_brand,
      availableSeat: driverInfo.availableSeat,
      driverPhoneNumber: driverInfo.account,
      driverContactPhoneNumber_1: driverInfo.contact1,
      driverContactPhoneNumber_2: driverInfo.contact2,
      note: driverInfo.note,
      serviceList: driverInfo.service_list.length
        ? driverInfo.service_list.reduce(
            (acc, service) => acc + service.name,
            '',
          )
        : '',
      updatedDate: driverInfo.updated_at,
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/hailStateV2/mutations.js